import '@babel/polyfill';
import React from 'react';
import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import ReactDOM from 'react-dom';
import { routerForBrowser, initializeCurrentLocation } from 'redux-little-router';
import App from './App';
import mainSaga from './common/sagas/mainSaga';
import routes from './routes';
import categoryReducer from './common/reducers/categoryReducer';
import categoryCollectionReducer from './common/reducers/categoryCollectionReducer';
import connectionReducer from './common/reducers/connectionReducer';
import queryResultsReducer from './common/reducers/queryResultsReducer';
import queryReducer from './common/reducers/queryReducer';
import tabReducer from './common/reducers/tabReducer';
import vbqlResultsReducer from './models/vbqlResults/vbqlResultsReducer';
import './index.less';

const {
  reducer: routerReducer,
  middleware: routerMiddleware,
  enhancer: routerEnhancer,
} = routerForBrowser({ routes });

const sagaMiddleware = createSagaMiddleware([mainSaga]);

const store = createStore(
  combineReducers({
    router: routerReducer,
    categoryCollection: categoryCollectionReducer,
    category: categoryReducer,
    connection: connectionReducer,
    query: queryReducer,
    queryResults: queryResultsReducer,
    tab: tabReducer,
    vbqlResults: vbqlResultsReducer,
  }),
  compose(routerEnhancer, applyMiddleware(routerMiddleware, sagaMiddleware)),
);

sagaMiddleware.run(mainSaga);

// ...after creating your store
const initialLocation = store.getState().router;

if (initialLocation) {
  store.dispatch(initializeCurrentLocation(initialLocation));
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root'),
);

/*

<div className="non-semantic-protector">
                  <h1 className="ribbon">
                    <strong className="ribbon-content">Coming Soon!</strong>
                  </h1>
                </div>

style={{ background: 'rgb(43, 64, 78)' }} */
